import emptyStateIconUrl from '../../../../../../public/images/empty-state.svg';

export const NotLoggedInWarning = () => (
    <div className="u-text-center u-mt32" data-testid="emptyWarning">
        <p className="u-t2 u-mb8">Hvis du logger inn kan du se dine favoritter</p>
        <a data-testid="notLoggedInWarning" className="button button--default u-mv32" href="https://www.finn.no/auth/login">
            Logg inn
        </a>
        <div className="u-mt32">
            <img src={emptyStateIconUrl.src} className="img-format__img u-size1of2" alt="Katt som tar på en badeball" />
        </div>
    </div>
);

export default NotLoggedInWarning;
